import type { ICorridor } from "../shared/session/interfaces/session";

/** Unique destination country codes from all link corridors (sorted). */
export const supportedDestinationCountries = (
  corridors: ICorridor[]
): string[] =>
  Array.from(new Set(corridors.map((c) => c.destinationCountryCode))).sort();

/**
 * Resolves the origin country for a destination. Prefers US when multiple
 * corridors share the same destination.
 */
export const resolveOriginForDestination = (
  corridors: ICorridor[],
  destinationCountryCode: string
): string | undefined => {
  const dest = destinationCountryCode.toUpperCase();
  const matches = corridors.filter(
    (c) => c.destinationCountryCode.toUpperCase() === dest
  );
  if (matches.length === 0) return undefined;
  const usMatch = matches.find((c) => c.originCountryCode === "US");
  return (usMatch ?? matches[0]).originCountryCode;
};

export const findCorridor = (
  corridors: ICorridor[],
  originCountryCode: string,
  destinationCountryCode: string
): ICorridor | null =>
  corridors.find(
    (c) =>
      c.originCountryCode === originCountryCode &&
      c.destinationCountryCode === destinationCountryCode
  ) ?? null;
